// Home.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import style from './Home.module.css';
import MultiplesImagenes from '../../Components/MultiplesImagenes/MultiplesImagenes';
import CardSellerPropertiesContainer from '../../Components/CardSellerPropertiesContainer/CardSellerPropertiesContainer';

const Home = () => {
  return (
    <div className={style.container}>
    <Link to="/operacion-externa/nueva" className={style.puntaCompradoraButton}>
      Cargar venta de punta compradora
    </Link>
    <CardSellerPropertiesContainer/>
    
    </div>
  );
};

export default Home;
